import { APP_INITIALIZER, Injector, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NotFoundComponent } from './not-found/not-found.component';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { OverviewComponent } from './overview/overview.component';
import {
  DxAccordionModule,
  DxAutocompleteModule,
  DxButtonModule,
  DxCheckBoxModule,
  DxDataGridModule,
  DxDateBoxModule,
  DxDrawerModule,
  DxFormModule,
  DxListModule,
  DxLoadIndicatorModule,
  DxLoadPanelModule,
  DxPopoverModule,
  DxPopupModule,
  DxRadioGroupModule,
  DxScrollViewModule,
  DxSelectBoxModule,
  DxTextAreaModule,
  DxTextBoxModule,
  DxToolbarModule,
  DxTreeViewModule,
  DxValidationGroupModule,
  DxValidationSummaryModule,
  DxValidatorModule
} from 'devextreme-angular';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { IncidentComponent } from './incident/incident.component';
import { ReportComponent } from './report/report.component';
import { AuthorizationComponent } from './authorization/authorization.component';
import { TokenInterceptor } from './interceptors/token-interceptor.service';
import { ReferenceDataComponent } from './overview/reference-data/reference-data.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { bootstrap } from './bootstrap/bootstrap';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { LoadingInterceptor } from './interceptors/loading-interceptor.service';
import { ReportImageComponent } from './report/report-image/report-image.component';
import { ReferenceComponent } from './reference/reference.component';
import { AboutComponent } from './about/about.component';
import { FileManagementComponent } from './file-management/file-management.component';

export function createTranslateLoader(http: HttpClient): TranslateLoader {
  return new MultiTranslateHttpLoader(http, [
    { prefix: './assets/i18n/', suffix: '.json' }
  ]);
}

@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
    OverviewComponent,
    IncidentComponent,
    ReportComponent,
    AuthorizationComponent,
    ReferenceDataComponent,
    ReportImageComponent,
    ReferenceComponent,
    AboutComponent,
    FileManagementComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    DxButtonModule,
    DxAccordionModule,
    DxLoadIndicatorModule,
    MatToolbarModule,
    MatSidenavModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    DxDrawerModule,
    DxListModule,
    DxRadioGroupModule,
    DxToolbarModule,
    DxTreeViewModule,
    DxPopupModule,
    DxDataGridModule,
    DxCheckBoxModule,
    DxFormModule,
    DxTextAreaModule,
    DxDateBoxModule,
    DxScrollViewModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    DxTextBoxModule,
    DxSelectBoxModule,
    DxValidatorModule,
    DxValidationSummaryModule,
    DxValidationGroupModule,
    DxLoadPanelModule,
    DxAutocompleteModule,
    DxPopoverModule,
    DxAccordionModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: bootstrap,
      deps: [Injector],
      multi: true
    },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
